var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-view",on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_c('svg-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticStyle:{"fill":"#f7223f"},attrs:{"width":"8px","height":"8px","icon":"close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }